// Моменты времени приходят в UTC — показываем по Астане (UTC+5)
const TZ = "Asia/Almaty";
const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

// Даты без времени (yyyy-MM-dd) уже по Астане — показываем как есть, без перевода зон
export function fmtDate(dt) {
  if (!dt) return "—";
  const m = DATE_ONLY.exec(dt);
  if (m) return `${m[3]}.${m[2]}.${m[1]}`;
  const d = new Date(dt);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("ru-RU", { timeZone: TZ });
}

export function fmtDayMonth(dt) {
  if (!dt) return "—";
  const m = DATE_ONLY.exec(dt);
  if (m) return `${m[3]}.${m[2]}`;
  const d = new Date(dt);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    timeZone: TZ,
  });
}

export function fmtDateTime(dt) {
  if (!dt) return "—";
  const d = new Date(dt);
  if (isNaN(d)) return "—";
  return d.toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: TZ,
  });
}

export function fmtMoney(v) {
  if (v === null || v === undefined || isNaN(Number(v))) return "—";
  return `${Math.round(Number(v)).toLocaleString("ru-RU")} ₸`;
}

export function fmtNum(v) {
  if (v === null || v === undefined) return "—";
  return Number(v).toLocaleString("ru-RU");
}

export function fmtPct(v) {
  if (v === null || v === undefined) return "—";
  return `${v}%`;
}

export function fmtDaysAgo(days) {
  if (days === null || days === undefined) return "—";
  if (days <= 0) return "сегодня";
  return `${days} дн. назад`;
}

export function daysAgo(dt) {
  if (!dt) return null;
  const d = new Date(dt);
  if (isNaN(d)) return null;
  const dayStart = (x) => {
    const s = x.toLocaleDateString("en-CA", { timeZone: TZ });
    return new Date(`${s}T00:00:00Z`).getTime();
  };
  return Math.round((dayStart(new Date()) - dayStart(d)) / 86400000);
}

// БИН/ИИН хранится строкой — восстанавливаем ведущие нули, если пришло число
export function fmtBin(bin) {
  if (bin === null || bin === undefined) return "";
  return String(bin).padStart(12, "0");
}

export function tariffLabel(c) {
  if (!c?.tariff) return "—";
  return c.isAnnual ? `${c.tariff} год` : c.tariff;
}

// Текст бейджа подписки: "PRO · 26 дн." / "PRO · истекла 24.10.2026"
export function subscriptionText(c) {
  if (!c?.tariff) return "Нет подписки";
  if (c.daysLeft === null || c.daysLeft === undefined) return tariffLabel(c);
  if (c.daysLeft < 0) return `${c.tariff} · истекла ${fmtDate(c.endAt)}`;
  if (c.daysLeft === 0) return `${c.tariff} · сегодня`;
  return `${tariffLabel(c)} · ${c.daysLeft} дн.`;
}

export function phoneDigits(phone) {
  return String(phone || "").replace(/\D/g, "");
}
